import { render, staticRenderFns } from "./productosAll.vue?vue&type=template&id=531ceda4"
import script from "./productosAll.vue?vue&type=script&lang=js"
export * from "./productosAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports